import { render, staticRenderFns } from "./BillingFileViewer.vue?vue&type=template&id=65a52910&scoped=true&"
import script from "./BillingFileViewer.vue?vue&type=script&lang=ts&"
export * from "./BillingFileViewer.vue?vue&type=script&lang=ts&"
import style0 from "./BillingFileViewer.vue?vue&type=style&index=0&id=65a52910&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a52910",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})
